import * as actionTypes from '../../actions/actiontypes';
import initialstate from '../initialstate';

export function stEntityIdReducer(state = initialstate.stEntityId, action) {
	let newState;

	switch (action.type) {
		case actionTypes.SET_SELECTED_STENTITY_ID: {
			newState = {
				currentValue: action.stEntityId,
				previousValue: state.currentValue
			};

			break;
		}
		case actionTypes.CLEAR_SELECTED_STENTITY_ID: {
			newState = {};

			break;
		}
		default:
			return state;
	}

	return newState || state;
}
